"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'googleDrive.directoryPicker.selectDirectory': '选择目录',
    'googleDrive.directoryPicker.selected': '已选择',
};
